const COMMENTS_SECTION = 'comments';
export { COMMENTS_SECTION };
